module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "d-table d-table__tasks marg-10-bottom",
    class: {
      'd-table--open': _vm.isOpen
    }
  }, [_c('thead', {
    staticClass: "pointer acc-header",
    on: {
      "click": _vm.setIsOpen
    }
  }, [_c('tr', [_c('th', {
    staticClass: "d-table__title"
  }, [_c('h4', [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th', {
    staticClass: "is-number d-table__thead__last"
  }, [_c('div', {
    staticClass: "number_and_acc"
  }, [_vm._v("\n        " + _vm._s(_vm.sumOfHours) + "\n        "), (!_vm.isOpen) ? _c('span', {
    staticClass: "icon-arrow-down4"
  }) : _vm._e(), _vm._v(" "), (_vm.isOpen) ? _c('span', {
    staticClass: "icon-arrow-up4"
  }) : _vm._e()])])])]), _vm._v(" "), (_vm.isOpen) ? [_c('tbody', [(_vm.tasks.length < 1) ? _c('tr', [_c('td', {
    staticStyle: {
      "width": "90%"
    }
  }, [_c('div', {
    staticClass: "italic",
    staticStyle: {
      "padding": "4px"
    }
  }, [_vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['no_subjects_assigned']))])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td')]) : _vm._e(), _vm._v(" "), _vm._l((_vm.sortedTasks), function(task) {
    return _c('tr', {
      key: task.id
    }, [_c('td', [_c('div', {
      staticClass: "task-with-edit",
      on: {
        "click": function($event) {
          return _vm.setEditTask(task)
        }
      }
    }, [(task.can_schedule || !task.hasOwnProperty('can_schedule')) ? _c('div', {
      staticClass: "subjects_subject subjects_subject__simple",
      style: ([{
        'border-left-color': task.color
      }, {
        'background-color': task.color
      }])
    }, [_vm._v("\n            " + _vm._s(task.name) + "\n          ")]) : _c('div', {
      staticClass: "subjects_subject subjects_subject--not-subject"
    }, [_vm._v(_vm._s(task.name))])])]), _vm._v(" "), _c('td', {
      staticClass: "td-calendars"
    }, [(_vm.getShowCalendarIfNotOwn(task)) ? _c('span', [_vm._v("\n        " + _vm._s(_vm.getShowCalendarIfNotOwn(task)) + "\n      ")]) : _vm._e()]), _vm._v(" "), (!task.hasOwnProperty('can_schedule')) ? _c('td', {
      staticClass: "is-number subject-hours-for-person",
      class: {
        'subject-hours-for-person--is-modified': _vm.getSubjectHours(task.id) !== task.hours
      },
      on: {
        "click": function($event) {
          return _vm.setActiveSubject(task.id)
        }
      }
    }, [_vm._v("\n        " + _vm._s(task.vHours != null ? task.vHours.toFixed(1) : '–') + "\n      ")]) : _c('td', {
      staticClass: "is-number"
    }, [_vm._v("\n        " + _vm._s(task.vHours != null ? task.vHours.toFixed(1) : '–') + "\n      ")])])
  })], 2), _vm._v(" "), _c('tfoot', [(_vm.isOpen && _vm.tasksWithoutSubject.length > 0) ? [_c('tr', {
    staticClass: "mini-table"
  }, [_c('td', {
    staticClass: "is-number"
  }, [_vm._v("Med brik")]), _vm._v(" "), _c('td', {
    staticClass: "is-number"
  }), _vm._v(" "), _c('td', {
    staticClass: "total-hours is-number"
  }, [_vm._v("\n          " + _vm._s(_vm.sumOfHoursWithSubject) + "\n        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "mini-table"
  }, [_c('td', {
    staticClass: "is-number"
  }, [_vm._v("Uden brik")]), _vm._v(" "), _c('td', {
    staticClass: "is-number"
  }), _vm._v(" "), _c('td', {
    staticClass: "total-hours is-number"
  }, [_vm._v("\n          " + _vm._s(_vm.sumOfHoursWithoutSubject) + "\n        ")])])] : _vm._e(), _vm._v(" "), _c('tr', {
    staticClass: "tfoot-headline"
  }, [_c('td', {
    staticClass: "is-number"
  }, [_vm._v(_vm._s(!_vm.isPoolsDeactivated ? _vm.i18n[_vm.locale]['assigned'] : ''))]), _vm._v(" "), _c('td', {
    staticClass: "is-number"
  }, [_vm._v(_vm._s(!_vm.isPoolsDeactivated ? _vm.i18n[_vm.locale]['difference'] : ''))]), _vm._v(" "), _c('td', {
    staticClass: "is-number"
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['time']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "is-number"
  }, [_vm._v(_vm._s(!_vm.isPoolsDeactivated ? _vm.assignedHours : ''))]), _vm._v(" "), _c('td', {
    staticClass: "is-number"
  }, [_vm._v(_vm._s(!_vm.isPoolsDeactivated ? _vm.getDiff : ''))]), _vm._v(" "), _c('td', {
    staticClass: "total-hours is-number"
  }, [_vm._v("\n        " + _vm._s(_vm.sumOfHours) + "\n      ")])])], 2)] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b77cc42a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SubjectsDistribution/SubjectsDistributionUserTable.vue
// module id = 1751
// module chunks = 1